import { Detection } from 'src/data-capture/types';

export function filterInsertedEntityConflicts(
  detections: Detection[],
  insertedEntityIds: string[],
): Detection[] {
  if (insertedEntityIds.length === 0) {
    return detections;
  }

  const insertedIds = new Set(insertedEntityIds);
  return detections.map(detection => {
    const conflicts = detection.conflicts.filter(
      conflict => !insertedIds.has(conflict.conflictingEntityFields.id),
    );
    return conflicts.length === detection.conflicts.length
      ? detection
      : { ...detection, conflicts };
  });
}
